import { useEffect, useRef, useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { nativeAudioDownload, requestAudioExport } from "../../lib/stemAudioExport";
import { mediaUrl } from "../../lib/publicAudioTools";

export default function StemDownloads({ task, settings, getAuthHeaders }) {
  const controller = useRef(null);
  const [busy, setBusy] = useState(false), [progress, setProgress] = useState(0), [error, setError] = useState("");
  const [result, setResult] = useState(null);
  useEffect(() => () => controller.current?.abort(), []);
  const convert = async (stem) => {
    if (controller.current || !task?.id || !settings.ready) return;
    const active = new AbortController(); controller.current = active;
    setBusy(true); setProgress(0); setError(""); setResult(null);
    try {
      const data = await requestAudioExport(`/stems/task/${task.id}/exports`, { format: settings.format, quality: settings.quality, stem },
        getAuthHeaders(), active.signal, setProgress);
      if (active.signal.aborted) return;
      setResult(data);
      nativeAudioDownload(data.assets.find(asset => stem ? asset.asset.startsWith(stem + ".") : asset.asset === "stems.zip"));
    } catch (failure) {
      if (!active.signal.aborted) setError(failure.response?.data?.detail?.message || failure.message || "No se pudo descargar");
    } finally {
      if (!active.signal.aborted) { controller.current = null; setBusy(false); }
    }
  };
  return <section aria-label="Descargar stems" className="space-y-3 border-t border-border pt-4">
    <h3 className="text-sm font-semibold">Descargar stems</h3>
    <div className="flex flex-wrap gap-2">
      {["vocals", "drums", "bass", "other"].map(stem => <Button key={stem} variant="outline" className="min-h-11 gap-2"
        disabled={busy || task?.status !== "completed" || !settings.ready} onClick={() => convert(stem)}>
        <Download className="h-4 w-4" />{stem[0].toUpperCase() + stem.slice(1)}
      </Button>)}
      <Button variant="outline" className="min-h-11 gap-2" disabled={busy || task?.status !== "completed" || !settings.ready} onClick={() => convert(null)}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}Todos · ZIP
      </Button>
    </div>
    {busy && <p role="status" className="text-xs text-signal">Exportando stems · {Math.round(progress)}%</p>}
    {error && <p role="alert" className="text-xs text-destructive">{error}</p>}
    {result?.warnings?.map(message => <p key={message} className="text-xs text-brass">{message}</p>)}
    {result && <div className="flex flex-wrap gap-3">{result.assets.map(asset => <a key={asset.asset} href={mediaUrl(asset.url)} download={asset.filename} rel="noreferrer"
      className="inline-flex min-h-11 items-center gap-2 text-sm text-signal underline"><Download className="h-4 w-4" />{asset.filename}</a>)}</div>}
  </section>;
}
